<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import CalendarMonth from "calendar-month";

export default {
  mixins: [fandomBasicMixin],
  components: {
    CalendarMonth
  },
  computed: {
    months() {
      const now = new Date();
      const year = now.getMonth() > 7 ? now.getFullYear() : now.getFullYear() - 1;
      return [{
        month: 8,
        year: year
      },
      {
        month: 9,
        year: year
      },
      {
        month: 10,
        year: year
      },
      {
        month: 11,
        year: year
      },
      {
        month: 0,
        year: year + 1
      },
      {
        month: 1,
        year: year + 1
      },
      {
        month: 2,
        year: year + 1
      },
      {
        month: 3,
        year: year + 1
      },
      {
        month: 4,
        year: year + 1
      },
      {
        month: 5,
        year: year + 1
      }]
    }
  }
};
</script>

<template>
  <div 
    :class="contentType" 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()"
    class="container py-5" 
    stripe-calendar-component
  >
    <calendar :eventsList="content.events" :months="months"></calendar>
  </div>
</template>

<style lang="scss">
</style>